module.exports = __webpack_public_path__ + "img/Speech.5b8a9dbc.png";